import React, { ReactElement } from 'react';
import classnames from 'classnames';
import { ClassNames } from '@emotion/react';
import { GridItemProps, DEFAULT_GAP } from '@bucketplace/design-system/bds';
import {
  VirtualizedList as BaseVirtualizedList,
  VirtualizedListProps as BaseVirtualizedListProps,
} from '@bucketplace/ui';

import {
  cssGridGap,
  cssGridItemGap,
  cssColumn,
  Gap,
} from 'styles/grids';

export interface VirtualizedListProps extends BaseVirtualizedListProps {
  gap: Gap;
  column: GridItemProps['column'];
}

export function VirtualizedList ({
  gap = DEFAULT_GAP,
  column,
  className,
  innerClassName,
  ...props
}: VirtualizedListProps): ReactElement {
  return (
    <ClassNames>
      { ({ css }) => (
        <BaseVirtualizedList
          className={classnames(
            className,
            css`
              display: flex;
              flex-wrap: wrap;
              ${cssGridGap(gap)};
            `
          )}
          innerClassName={classnames(
            innerClassName,
            css`
              box-sizing: border-box;
              display: inline-block;
              vertical-align: top;
              ${cssGridItemGap(gap)};
              ${cssColumn(column)};
            `
          )}
          {...props}
        />
      ) }
    </ClassNames>
  );
}
